import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  OnDestroy,
  Input
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidatorFn,
  Validators
} from '@angular/forms';
import { IOntarioHealthCard } from '@appgen-health-crm/api-interfaces';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ontario-hc',
  templateUrl: './ontario-hc.component.html',
  styleUrls: ['./ontario-hc.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OntarioHcComponent implements OnInit, OnDestroy {
  constructor(private fb: FormBuilder) {}
  cardForm: FormGroup;
  active = true;

  private _disabled: boolean = null;
  @Input()
  set disabled(val: boolean) {
    if (val) {
      this.cardForm && this.cardForm.disable();
    } else {
      this.cardForm?.disabled && this.cardForm.enable();
    }
    this._disabled = val;
  }
  get disabled(): boolean {
    return this._disabled;
  }
  @Output() changeEvent = new EventEmitter<{
    value: IOntarioHealthCard;
    valid: boolean;
  }>();
  ngOnInit(): void {
    this.cardForm = this.fb.group(
      {
        hcNum: [null],
        hcVer: [null],
        hcEff: [null],
        hcExp: [null]
      },
      {
        updateOn: 'blur'
      }
    );

    this.applyValidators(false);
    if (this.disabled) this.cardForm.disable();
    this.cardForm.valueChanges.subscribe(v => {
      const { hcNum, hcVer, hcEff, hcExp } = v || {};
      const valid = !hcNum && !hcVer && !hcEff && !hcExp;
      if (valid) {
        this.cardForm.reset({}, { emitEvent: false });
        this.removeValidators();
      } else {
        this.applyValidators();
      }
      this.changeEvent.emit({ valid: valid || this.cardForm.valid, value: v });
    });
  }

  applyValidators(makeDirty: boolean = true) {
    this.cardForm
      .get('hcNum')
      .setValidators([
        Validators.required,
        Validators.pattern(/^([0-9]*)$/),
        Validators.minLength(10),
        Validators.maxLength(10)
      ]);
    this.cardForm
      .get('hcVer')
      .setValidators([Validators.required, Validators.pattern('[A-Za-z]{2}')]);
    this.cardForm
      .get('hcEff')
      .setValidators([Validators.required, this.dateValidator()]);
    this.cardForm
      .get('hcExp')
      .setValidators([Validators.required, this.dateValidator()]);
    for (const i in this.cardForm.controls) {
      makeDirty && this.cardForm.controls[i].markAsDirty();
      this.cardForm.controls[i].updateValueAndValidity({ emitEvent: false });
    }
  }

  removeValidators() {
    this.cardForm.get('hcNum').setValidators([]);
    this.cardForm.get('hcVer').setValidators([]);
    this.cardForm.get('hcEff').setValidators([]);
    this.cardForm.get('hcExp').setValidators([]);
    for (const i in this.cardForm.controls) {
      this.cardForm.controls[i].markAsPristine();
      this.cardForm.controls[i].setErrors([]);
      this.cardForm.controls[i].updateValueAndValidity({ emitEvent: false });
    }
  }

  ngOnDestroy() {
    this.active = false;
  }

  dateValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null =>
      !isNaN(Date.parse(control.value)) ? null : { invalidDate: control.value };
  }

  resetForm(): void {
    this.cardForm.reset();
  }

  patchValue(value: IOntarioHealthCard) {
    this.cardForm?.patchValue(value);
  }

  markAsDirty() {
    for (const key in this.cardForm.controls) {
      if (Object.prototype.hasOwnProperty.call(this.cardForm.controls, key)) {
        this.cardForm.controls[key].markAsDirty();
        this.cardForm.controls[key].updateValueAndValidity();
      }
    }
  }
}
